<template>
    <div class="container">
        <b-overlay :show="loading" :opacity="0.3">
            <div v-for="n in rows" :key="n" class="card p-3 mb-5">
                <div class="row mb-3">
                    <div class="col-md-6">
                        <div class="placeholder-paragraph aligned-left">
                            <div class="line"></div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <div :class="placeholderType + ' ' + placeholderAlign">
                            <div class="line"></div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="placeholder-paragraph aligned-left">
                            <div class="line"></div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="placeholder-paragraph aligned-left">
                            <div class="line"></div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="placeholder-paragraph aligned-left">
                            <div class="line"></div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="placeholder-paragraph aligned-left">
                            <div class="line"></div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="placeholder-paragraph aligned-left">
                            <div class="line"></div>
                        </div>
                    </div>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    export default {
        name: "ProductCardPlaceholder",
        
        props: {
            loading: {
              type: Boolean,
              default: false
            },
            rows: {
              type: Number,
              default: 1
            },
            type: {
              type: String,
              default: "media-square"
            },
            align:{
              type: String,
              default: "left"
            }
        },
        
        computed: {
            placeholderAlign() {
                if (this.align === "left") return "aligned-left";
                if (this.align === "center") return "aligned-centered";
                if (this.align === "right") return "aligned-right";
                return "aligned-left";
            },
            
            placeholderType() {
                if (this.type === "paragraph") return "placeholder-paragraph";
                if (this.type === "media") return "placeholder-media"
                if (this.type === "media-square") return "placeholder-media-square"
                return "placeholder-paragraph";
            }
        }
    }
</script>

<style scoped>
    .placeholder-paragraph .line {
        position: relative;
        width: 87%;
        margin: 20px 0;
    }

    .placeholder-paragraph .line, .placeholder-paragraph .line::before, .placeholder-paragraph .line::after {
        animation-duration: .8s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: shimmer;
        animation-timing-function: linear;
        background: #f4f5f8;
        background: linear-gradient(to right, #e3e7ed 8%, #cdd4e0 18%, #e3e7ed 33%);
        background-size: 800px 10px;
        height: 8px;
    }

    .placeholder-paragraph .line::before, .placeholder-paragraph .line::after {
        content: '';
        position: absolute;
        left: 0;
    }

    .placeholder-paragraph .line::before {
        top: -20px;
        width: 84%;
    }

    .placeholder-paragraph .line::after {
        bottom: -20px;
        width: 64%;
    }

    .placeholder-paragraph .line + .line {
        margin-top: 52px;
        width: 93%;
    }

    .placeholder-paragraph .line + .line::before {
        width: 88%;
    }

    .placeholder-paragraph .line + .line::after {
        width: 36%;
    }

    .placeholder-paragraph.aligned-centered {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .placeholder-paragraph.aligned-centered .line::before {
        margin-left: 50%;
        left: -42%;
    }

    .placeholder-paragraph.aligned-centered .line::after {
        margin-left: 50%;
        left: -32%;
    }

    .placeholder-paragraph.aligned-centered .line + .line {
        margin-top: 32px;
    }

    .placeholder-paragraph.aligned-centered .line + .line::before {
        left: -44%;
    }

    .placeholder-paragraph.aligned-centered .line + .line::after {
        left: -18%;
    }

    .placeholder-paragraph.aligned-right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .placeholder-paragraph.aligned-right .line::before, .placeholder-paragraph.aligned-right .line::after {
        left: auto;
        right: 0;
    }

    .placeholder-paragraph.aligned-right .line + .line {
        margin-top: 32px;
    }

    .placeholder-media .line {
        position: relative;
        margin-top: 8px;
        margin-bottom: 25px;
        margin-left: 70px;
        height: 16px;
    }

    .placeholder-media .line::before {
        content: '';
        position: absolute;
        top: -11px;
        left: -70px;
        width: 55px;
        height: 55px;
        border-radius: 100%;
    }

    .placeholder-media .line::after {
        content: '';
        position: absolute;
        bottom: -20px;
        left: 0;
        width: 65%;
        height: 8px;
    }

    .placeholder-media .line, .placeholder-media .line::before, .placeholder-media .line::after {
        animation-duration: .8s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: shimmer;
        animation-timing-function: linear;
        background: #e3e7ed;
        background: linear-gradient(to right, #e3e7ed 8%, #cdd4e0 18%, #e3e7ed 33%);
        background-size: 800px 10px;
    }

    .placeholder-media-square .line {
        position: relative;
        margin-top: 8px;
        margin-bottom: 25px;
        margin-left: 70px;
        height: 16px;
    }

    .placeholder-media-square .line::before {
        content: '';
        position: absolute;
        top: -11px;
        left: -70px;
        width: 55px;
        height: 55px;
        bborder-radius: 100%;
    }

    .placeholder-media-square .line::after {
        content: '';
        position: absolute;
        bottom: -20px;
        left: 0;
        width: 65%;
        height: 8px;
    }

    .placeholder-media-square .line, .placeholder-media-square .line::before, .placeholder-media-square .line::after {
        animation-duration: .8s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: shimmer;
        animation-timing-function: linear;
        background: #e3e7ed;
        background: linear-gradient(to right, #e3e7ed 8%, #cdd4e0 18%, #e3e7ed 33%);
        background-size: 800px 10px;
    }
</style>